import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Once you've set up your Apollo GraphOS application in Entra ID, you need to assign users to it so they can access GraphOS.
You can assign individual users or groups from the `}<strong parentName="p">{`User and groups`}</strong>{` page of your Apollo GraphOS application in Entra ID.`}</p>
    <p>{`You may want to begin by adding yourself individually and then testing SSO by clicking `}<strong parentName="p">{`Test`}</strong>{` at the bottom of the `}<strong parentName="p">{`Single sign-on`}</strong>{` page.`}</p>
    <img src="/f26459fb2b8ed291c1412b05da4877aa/entra-sso-test.jpg" alt="SSO testing in Microsoft Entra ID" className="screenshot" width="700" />
    <p>{`Once you've successfully tested your own user's ability to use SSO, add any applicable users or groups.
Repeat these steps whenever you want to grant GraphOS Studio access to a new user or group.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      